import { ConditionalLink } from "components/conditionalLink";
import { Tag } from "components/DesignSystem/Tag/Tag";
import { taskStatusOptions } from "./TaskStatusWithFiles";
import { STATUS_UNPAID } from "../Task1120FilterOptions";

export const PrevYearFilingStatus = ({
  taskList,
}: {
  taskList:
    | {
        task_uuid: string;
        status: string;
      }[]
    | null;
}) => {
  if (!taskList || taskList.length === 0) {
    return "-";
  }

  const filteredTaskListLength = taskList.filter(
    (filing) => filing.status && filing.status !== STATUS_UNPAID
  ).length;

  return (
    <div>
      {Boolean(filteredTaskListLength) && (
        <div className="t-text-text-30 t-text-caption">
          {filteredTaskListLength} filings
        </div>
      )}
      <div className="t-flex t-gap-1 t-flex-wrap">
        {taskList.map((filing) => {
          const selectedStatus = taskStatusOptions[filing.status];
          return (
            <ConditionalLink
              to={filing.task_uuid && `/tax/filings/${filing.task_uuid}`}
              key={filing.task_uuid}
            >
              <Tag
                tagType={selectedStatus?.color || "orange"}
                rounded
                icon={false}
              >
                {selectedStatus?.text || "-"}
              </Tag>
            </ConditionalLink>
          );
        })}
      </div>
    </div>
  );
};
